document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const header = document.querySelector('.fur-header');
  const updateHeader = () => { if (!header) return; const scrolled = window.scrollY > 20; header.classList.toggle('scrolled', scrolled); body.classList.toggle('fur-header-scrolled', scrolled); };
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });

  // Random homepage hero image (male/female campaign)
  const randomHero = document.querySelector('[data-fur-hero-random]');
  if (randomHero) {
    const images = [randomHero.dataset.heroImageA, randomHero.dataset.heroImageB].filter(Boolean);
    if (images.length > 1) {
      const chosen = images[Math.floor(Math.random() * images.length)];
      randomHero.src = chosen;
    }
  }

  const resetRestockMessages = () => {
    const formEl = document.querySelector('[data-fur-restock-form]');
    if (!formEl) return;
    formEl.classList.remove('is-success');
    formEl.querySelector('[data-fur-restock-success]')?.setAttribute('hidden', 'hidden');
    formEl.querySelector('[data-fur-restock-error]')?.setAttribute('hidden', 'hidden');
  };

  const setRestockOpen = (open, focus = false) => {
    const restock = document.querySelector('[data-fur-restock]');
    if (!restock) return;
    restock.classList.toggle('is-open', Boolean(open));
    restock.setAttribute('aria-hidden', open ? 'false' : 'true');
    restock.hidden = false;
    if (!open) resetRestockMessages();
    if (open && focus) {
      window.setTimeout(() => restock.querySelector('input[type="email"]')?.focus(), 280);
    }
  };

  // Product variant picker — stable Shopify inventory logic.
  const form = document.querySelector('.fur-product-form');
  const json = document.querySelector('.fur-product-variants');
  let furProductVariants = [];

  const isSellableVariant = (variant) => {
    if (!variant) return false;
    const qty = Number(variant.inventory_quantity ?? variant.inventoryQuantity ?? 0);
    const policy = String(variant.inventory_policy ?? variant.inventoryPolicy ?? '').toLowerCase();
    const management = variant.inventory_management ?? variant.inventoryManagement;
    // Shopify is de bron. variant.available is leidend, maar sommige storefronts geven
    // bij custom JSON toch false terug terwijl inventory_quantity al > 0 is. Daarom
    // accepteren we ook positieve voorraad. Voorraad 0 blijft geblokkeerd als
    // 'Doorgaan met verkopen wanneer niet op voorraad' uit staat.
    return variant.available === true || qty > 0 || policy === 'continue' || management === null || management === '';
  };

  if (form && json) {
    try { furProductVariants = JSON.parse(json.textContent); } catch (e) { furProductVariants = []; }
    const idInput = form.querySelector('.fur-variant-id');
    // Belangrijk: gebruik ALLE option fieldsets, ook hidden ones, zodat de volgorde
    // exact gelijk blijft aan Shopify variant.options. Anders kan de maat-logica
    // per ongeluk geen variant matchen en alles als uitverkocht tonen.
    const optionGroups = () => Array.from(form.querySelectorAll('.fur-pdp-option, .fur-option'));

    const getSelectedOptions = () => optionGroups().map((group) => {
      const checked = group.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : null;
    });

    const findExactVariant = (options) => {
      const selected = options.filter((option) => option !== null && option !== undefined);
      return furProductVariants.find((variant) => {
        if (!variant || !Array.isArray(variant.options)) return false;
        return variant.options.every((variantOption, index) => {
          const selectedOption = selected[index];
          return selectedOption === undefined || selectedOption === null || variantOption === selectedOption;
        });
      });
    };

    const updateSizeAvailability = () => {
      const groups = optionGroups();
      const sizeGroup = form.querySelector('.fur-pdp-option--sizes');
      if (!sizeGroup || !furProductVariants.length) return;
      const sizeIndex = groups.indexOf(sizeGroup);
      const selected = getSelectedOptions();
      let matchedAnySize = false;
      const sizeInputs = Array.from(sizeGroup.querySelectorAll('input[type="radio"]'));
      sizeInputs.forEach((input) => {
        const candidateOptions = selected.slice();
        candidateOptions[sizeIndex] = input.value;
        const candidate = findExactVariant(candidateOptions);
        const sellable = isSellableVariant(candidate);
        if (candidate) matchedAnySize = true;
        // Uitverkochte maten moeten aanklikbaar blijven zodat de klant
        // de juiste maat kan kiezen en zich kan aanmelden voor Notify Me.
        input.disabled = false;
        input.removeAttribute('disabled');
        const label = sizeGroup.querySelector(`label[for="${CSS.escape(input.id)}"]`);
        label?.classList.toggle('is-disabled', candidate ? !sellable : false);
        label?.setAttribute('aria-disabled', candidate && !sellable ? 'true' : 'false');
      });
      // Als Shopify-opties niet matchen door een afwijkende setup, zet dan niet alles
      // doorgestreept. De Add to Cart check blijft de uiteindelijke beveiliging.
      if (!matchedAnySize) {
        sizeInputs.forEach((input) => {
          input.disabled = false;
          input.removeAttribute('disabled');
          const label = sizeGroup.querySelector(`label[for="${CSS.escape(input.id)}"]`);
          label?.classList.remove('is-disabled');
          label?.setAttribute('aria-disabled', 'false');
        });
      }

      // Niet automatisch terugschakelen naar een beschikbare maat;
      // uitverkochte maten blijven bewust selecteerbaar voor restock notify.
    };

    const updateRestockVariantField = (variant) => {
      if (!variant) return;
      const titleField = document.querySelector('[data-fur-restock-variant]');
      const idField = document.querySelector('[data-fur-restock-variant-id]');
      const inventoryField = document.querySelector('[data-fur-restock-inventory-item-id]');
      const imageField = document.querySelector('[data-fur-restock-image-url]');
      if (titleField) titleField.value = variant.title || variant.id || '';
      if (idField) idField.value = variant.id || '';
      if (inventoryField) inventoryField.value = variant.inventory_item_id || variant.inventoryItemId || '';
      if (imageField && variant.image_url) imageField.value = variant.image_url;
    };

    const updateVariant = () => {
      updateSizeAvailability();
      const selected = getSelectedOptions();
      const match = findExactVariant(selected);
      const sellable = isSellableVariant(match);
      if (match && idInput) idInput.value = match.id;
      updateRestockVariantField(match);

      const button = form.querySelector('.fur-atc');
      if (button) {
        button.disabled = false;
        button.toggleAttribute('data-sold-out', !sellable);
        button.setAttribute('aria-disabled', sellable ? 'false' : 'true');
        button.textContent = sellable ? 'Toevoegen aan winkelwagen' : 'Meld mij wanneer beschikbaar';
      }
      const stock = form.querySelector('.fur-pdp-stock');
      setRestockOpen(!sellable, false);
      if (stock) stock.textContent = sellable ? 'Online beschikbaar · Verwerking 1–3 werkdagen' : 'Uitverkocht · kies deze maat en laat je e-mailadres achter';
    };



    // v58: sold-out size labels must remain selectable for Notify Me.
    form.querySelectorAll('.fur-pdp-option--sizes label').forEach((label) => {
      label.addEventListener('click', (event) => {
        const forId = label.getAttribute('for');
        if (!forId) return;
        const input = document.getElementById(forId);
        if (!input) return;
        event.preventDefault();
        input.disabled = false;
        input.removeAttribute('disabled');
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    form.addEventListener('change', updateVariant);
    updateVariant();
  }



  // v59 — sold-out Add to Cart opens Notify Me smoothly.
  document.addEventListener('click', (event) => {
    const atc = event.target.closest('.fur-pdp-atc[data-sold-out="true"]');
    if (!atc) return;
    setRestockOpen(true, true);
  }, true);

  // Robust Shop mega menu: hover + keyboard, keeps menu open while moving over it.
  const shopTrigger = document.querySelector('[data-fur-shop-trigger]');
  const shopLink = shopTrigger?.querySelector('.fur-shop-trigger__link');
  let shopTimer;
  const openShop = () => {
    window.clearTimeout(shopTimer);
    shopTrigger?.classList.add('is-open');
    shopLink?.setAttribute('aria-expanded', 'true');
  };
  const closeShop = () => {
    shopTimer = window.setTimeout(() => {
      shopTrigger?.classList.remove('is-open');
      shopLink?.setAttribute('aria-expanded', 'false');
    }, 140);
  };
  if (shopTrigger) {
    shopTrigger.addEventListener('mouseenter', openShop);
    shopTrigger.addEventListener('mouseleave', closeShop);
    shopTrigger.addEventListener('focusin', openShop);
    shopTrigger.addEventListener('focusout', closeShop);
  }

  // Make the Shop mega menu follow the hovered category.
  const mega = document.querySelector('.fur-mega');
  const nav = document.querySelector('[data-fur-mega-nav]');
  if (mega && nav) {
    const items = Array.from(nav.querySelectorAll('.fur-mega__item'));
    const indicator = nav.querySelector('.fur-mega__indicator');
    const feature = mega.querySelector('[data-fur-mega-feature]');
    const preview = mega.querySelector('[data-fur-mega-preview]');
    const featureImg = mega.querySelector('[data-fur-mega-feature-img]');
    const previewImg = mega.querySelector('[data-fur-mega-preview-img]');
    const title = mega.querySelector('[data-fur-mega-title]');
    const subtitle = mega.querySelector('[data-fur-mega-subtitle]');

    const moveIndicator = (item) => {
      if (!indicator || !item) return;
      const navRect = nav.getBoundingClientRect();
      const itemRect = item.getBoundingClientRect();
      indicator.style.height = `${itemRect.height}px`;
      indicator.style.transform = `translateY(${itemRect.top - navRect.top}px)`;
      indicator.style.opacity = '1';
    };

    const updateImages = (item) => {
      if (!item) return;
      items.forEach((el) => el.classList.toggle('is-active', el === item));
      moveIndicator(item);

      const nextFeature = item.dataset.featureSrc;
      const nextPreview = item.dataset.previewSrc;
      const nextTitle = item.dataset.title || item.textContent.trim();
      const nextSubtitle = item.dataset.subtitle || 'Premium unisex streetwear essentials';
      const nextHref = item.getAttribute('href') || '/collections/all';
      const nextPanel = item.dataset.panel || 'new-arrivals';
      mega.querySelectorAll('[data-fur-mega-panel]').forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.furMegaPanel === nextPanel);
      });

      feature?.classList.add('is-changing');
      preview?.classList.add('is-changing');

      window.setTimeout(() => {
        if (featureImg && nextFeature) featureImg.src = nextFeature;
        if (previewImg && nextPreview) previewImg.src = nextPreview;
        if (title) title.textContent = nextTitle;
        if (subtitle) subtitle.textContent = nextSubtitle;
        if (feature) feature.href = nextHref;
        if (preview) preview.href = nextHref;
        feature?.classList.remove('is-changing');
        preview?.classList.remove('is-changing');
      }, 80);
    };

    items.forEach((item) => {
      item.addEventListener('mouseenter', () => updateImages(item));
      item.addEventListener('focus', () => updateImages(item));
    });

    const active = nav.querySelector('.fur-mega__item.is-active') || items[0];
    updateImages(active);
    window.addEventListener('resize', () => moveIndicator(nav.querySelector('.fur-mega__item.is-active')), { passive: true });
  }

  // Search overlay dropdown
  const searchOverlay = document.querySelector('[data-fur-search-overlay]');
  const searchInput = document.querySelector('[data-fur-search-input]');
  const searchCards = Array.from(document.querySelectorAll('[data-fur-search-results] .fur-product-card'));
  const openSearch = (event) => {
    if (event) event.preventDefault();
    body.classList.add('fur-search-open', 'fur-no-scroll');
    searchOverlay?.setAttribute('aria-hidden', 'false');
    window.setTimeout(() => searchInput?.focus(), 50);
  };
  const closeSearch = () => {
    body.classList.remove('fur-search-open');
    searchOverlay?.setAttribute('aria-hidden', 'true');
    if (!body.classList.contains('fur-cart-open')) body.classList.remove('fur-no-scroll');
  };
  document.querySelectorAll('[data-fur-search-open], [data-fur-search-open-footer]').forEach((el) => el.addEventListener('click', openSearch));
  document.querySelectorAll('[data-fur-search-close]').forEach((el) => el.addEventListener('click', closeSearch));
  document.querySelectorAll('[data-fur-search-term]').forEach((el) => {
    el.addEventListener('click', () => {
      if (!searchInput) return;
      searchInput.value = el.dataset.furSearchTerm || '';
      searchInput.dispatchEvent(new Event('input', { bubbles: true }));
      searchInput.focus();
    });
  });
  searchInput?.addEventListener('input', () => {
    const q = searchInput.value.trim().toLowerCase();
    searchCards.forEach((card) => {
      const haystack = (card.dataset.productTitle || card.textContent || '').toLowerCase();
      card.classList.toggle('is-hidden', q && !haystack.includes(q));
    });
  });

  // Cart drawer + Ajax add to cart
  const cartDrawer = document.querySelector('[data-fur-cart-drawer]');
  const cartBody = document.querySelector('[data-fur-cart-body]');
  const cartFoot = document.querySelector('[data-fur-cart-foot]');
  const cartTotal = document.querySelector('[data-fur-cart-total]');
  const cartCountEls = Array.from(document.querySelectorAll('[data-fur-cart-count]'));
  const cartCountTitle = document.querySelector('[data-fur-cart-count-title]');
  const cartProgressWrap = document.querySelector('[data-fur-cart-progress-wrap]');
  const cartFreeShippingCopy = document.querySelector('[data-fur-free-shipping-copy]');
  const cartFreeShippingBar = document.querySelector('[data-fur-free-shipping-bar]');
  const freeShippingThreshold = 10000;

  const money = (cents) => {
    const amount = (Number(cents || 0) / 100).toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' });
    return amount.replace(',00', '');
  };

  const updateFreeShippingProgress = (cart) => {
    if (!cartProgressWrap || !cartFreeShippingCopy || !cartFreeShippingBar) return;
    const total = Number(cart.total_price || 0);
    const remaining = Math.max(freeShippingThreshold - total, 0);
    const percent = Math.min((total / freeShippingThreshold) * 100, 100);
    cartProgressWrap.hidden = cart.item_count === 0;
    cartFreeShippingBar.style.width = `${percent}%`;
    cartFreeShippingCopy.textContent = remaining <= 0 ? 'Gratis verzending is geactiveerd.' : `Nog ${money(remaining)} tot gratis verzending.`;
  };

  const renderCart = (cart) => {
    if (!cartBody) return;
    cartCountEls.forEach((el) => { el.textContent = cart.item_count > 0 ? cart.item_count : ''; });
    if (cartCountTitle) cartCountTitle.textContent = cart.item_count > 0 ? ` · ${cart.item_count}` : '';
    if (cartTotal) cartTotal.textContent = money(cart.total_price);
    if (cartFoot) cartFoot.hidden = cart.item_count === 0;
    updateFreeShippingProgress(cart);

    if (!cart.item_count) {
      cartBody.innerHTML = `<div class="fur-cart-empty fur-cart-empty--premium"><p class="fur-page__eyebrow">Your dreams are still waiting</p><strong>Je winkelwagen is leeg.</strong><p>Ontdek Club des Rêveurs 01.</p><a class="fur-button" href="/collections/all">Shop de drop</a></div>`;
      return;
    }

    cartBody.innerHTML = cart.items.map((item) => {
      const title = item.product_title.replace(/"/g, '&quot;');
      const itemUrl = item.url || `/products/${item.handle || ''}`;
      const image = item.image ? `<a class="fur-cart-drawer__image-link" href="${itemUrl}" aria-label="Bekijk ${title}"><img src="${item.image}" alt="${title}"></a>` : '';
      const variant = item.variant_title ? `${item.variant_title} · ` : '';
      return `<div class="fur-cart-drawer__item" data-line-key="${item.key}" style="--item-index:${cart.items.indexOf(item)}">${image}<div class="fur-cart-drawer__meta"><button type="button" class="fur-cart-remove" data-fur-remove-item="${item.key}" data-fur-remove-qty="${item.quantity}" aria-label="Verwijder 1 stuk ${title}">×</button><strong>${item.product_title}</strong><span>${variant}Aantal ${item.quantity}</span><small>${money(item.final_line_price)}</small></div></div>`;
    }).join('');
    window.requestAnimationFrame(() => cartBody.querySelectorAll('.fur-cart-drawer__item').forEach((item) => item.classList.add('is-visible')));
  };

  const refreshCart = async () => {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();
      renderCart(cart);
    } catch (e) {}
  };
  const openCart = async (event) => {
    if (event) event.preventDefault();
    body.classList.add('fur-cart-open', 'fur-no-scroll');
    cartDrawer?.setAttribute('aria-hidden', 'false');
    await refreshCart();
  };


  const showAddedToast = (message = 'Toegevoegd aan winkelwagen') => {
    let toast = document.querySelector('[data-fur-add-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'fur-add-toast';
      toast.setAttribute('data-fur-add-toast', '');
      toast.innerHTML = '<span class="fur-add-toast__mark" aria-hidden="true"></span><span class="fur-add-toast__text"><strong>Toegevoegd</strong><span>Je winkelwagen is bijgewerkt.</span></span>';
      document.body.appendChild(toast);
    }
    const line = toast.querySelector('.fur-add-toast__text span');
    if (line) line.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(toast._furTimer);
    toast._furTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 1900);
  };
  const closeCart = () => {
    body.classList.remove('fur-cart-open');
    cartDrawer?.setAttribute('aria-hidden', 'true');
    if (!body.classList.contains('fur-search-open')) body.classList.remove('fur-no-scroll');
  };
  document.querySelectorAll('[data-fur-cart-open]').forEach((el) => el.addEventListener('click', openCart));
  document.querySelectorAll('[data-fur-cart-close]').forEach((el) => el.addEventListener('click', closeCart));



  // Recently viewed products
  const currentProductScript = document.querySelector('[data-fur-current-product]');
  const recentGrid = document.querySelector('[data-fur-recently-viewed]');
  const recentSection = document.querySelector('[data-fur-recently-viewed-section]');
  if (currentProductScript) {
    const key = 'furRecentlyViewedProducts';
    let currentProduct = null;
    try { currentProduct = JSON.parse(currentProductScript.textContent); } catch (e) {}
    let recent = [];
    try { recent = JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) { recent = []; }

    if (recentGrid && currentProduct) {
      const visible = recent.filter((item) => item && String(item.id) !== String(currentProduct.id)).slice(0, 4);
      if (visible.length) {
        recentSection?.removeAttribute('hidden');
        window.setTimeout(() => recentSection?.classList.add('is-visible'), 40);
        recentGrid.innerHTML = visible.map((item) => {
          const image = item.image ? `<img class="fur-product-card__image" src="${item.image}" alt="${String(item.title || '').replace(/"/g, '&quot;')}" loading="lazy">` : '';
          const hover = item.hover || item.image;
          const hoverImg = hover ? `<img class="fur-product-card__hover" src="${hover}" alt="${String(item.title || '').replace(/"/g, '&quot;')}" loading="lazy">` : '';
          const quickAdd = item.available && item.variantId
            ? `<form method="post" action="/cart/add" class="fur-card-quick-add" data-fur-quick-add><input type="hidden" name="id" value="${item.variantId}"><button class="fur-product-card__plus" type="submit" aria-label="Toevoegen aan winkelwagen">+</button></form>`
            : `<a class="fur-product-card__plus" href="${item.url}" aria-label="Bekijk product">+</a>`;
          return `<article class="fur-product-card" data-product-id="${item.id}" data-product-title="${String(item.title || '').replace(/"/g, '&quot;')}"><a href="${item.url}" class="fur-product-card__media">${image}${hoverImg}</a><div class="fur-product-card__info"><a class="fur-product-card__title" href="${item.url}">${item.title}</a><span class="fur-product-card__price">${item.price || ''}</span><span class="fur-product-card__meta">${item.colour || 'Unisex'} · Unisex</span>${quickAdd}</div></article>`;
        }).join('');
      }
    }

    if (currentProduct) {
      const nextRecent = [currentProduct, ...recent.filter((item) => item && String(item.id) !== String(currentProduct.id))].slice(0, 12);
      try { localStorage.setItem(key, JSON.stringify(nextRecent)); } catch (e) {}
    }
  }


  const animateQuickAdd = (submit) => {
    if (!submit) return;
    const form = submit.closest('.fur-card-quick-add');
    const card = submit.closest('.fur-product-card') || submit.closest('.fur-cart-rec-wrap');
    if (!form || !card) return;
    form.classList.add('is-added');
    card.classList.add('is-quick-added');

    const sourceRect = submit.getBoundingClientRect();
    const cartTarget = document.querySelector('[data-fur-cart-open]') || document.querySelector('.fur-cart-drawer__head strong');
    const targetRect = cartTarget?.getBoundingClientRect();
    const token = document.createElement('span');
    token.className = 'fur-add-token';
    token.style.left = `${sourceRect.left + sourceRect.width / 2}px`;
    token.style.top = `${sourceRect.top + sourceRect.height / 2}px`;
    if (targetRect) {
      token.style.setProperty('--fur-token-x', `${targetRect.left + targetRect.width / 2 - (sourceRect.left + sourceRect.width / 2)}px`);
      token.style.setProperty('--fur-token-y', `${targetRect.top + targetRect.height / 2 - (sourceRect.top + sourceRect.height / 2)}px`);
    } else {
      token.style.setProperty('--fur-token-x', '0px');
      token.style.setProperty('--fur-token-y', '-26px');
    }
    document.body.appendChild(token);

    window.setTimeout(() => token.remove(), 780);
    window.setTimeout(() => {
      form.classList.remove('is-added');
      card.classList.remove('is-quick-added');
    }, 900);
  };

  document.addEventListener('submit', async (event) => {
    const productForm = event.target.closest('form[action*="/cart/add"]');
    if (!productForm) return;
    if (!productForm.classList.contains('fur-product-form') && !productForm.classList.contains('fur-card-quick-add')) return;
    event.preventDefault();
    const submit = productForm.querySelector('[type="submit"]');
    const original = submit?.textContent;
    if (submit) {
      submit.dataset.originalText = original || submit.textContent || '+';
      if (submit.classList.contains('fur-product-card__plus')) {
        submit.classList.add('is-loading');
        submit.dataset.furFixedLabel = submit.textContent || '+';
        submit.textContent = submit.dataset.furFixedLabel;
        submit.setAttribute('aria-label', 'Wordt toegevoegd');
      } else {
        submit.textContent = 'Bezig...';
      }
      submit.disabled = true;
    }
    try {
      if (productForm.classList.contains('fur-product-form') && furProductVariants.length) {
        const selectedId = Number(productForm.querySelector('.fur-variant-id')?.value || 0);
        const selectedVariant = furProductVariants.find((v) => Number(v.id) === selectedId);
        const sellable = isSellableVariant(selectedVariant);
        if (!sellable) {
          const stock = productForm.querySelector('.fur-pdp-stock');
          setRestockOpen(true, true);
          if (stock) stock.textContent = 'Uitverkocht · laat je e-mailadres achter voor een melding';
          throw new Error('Variant sold out');
        }
      }
      const formData = new FormData(productForm);
      const res = await fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } });
      if (!res.ok) throw new Error('Add to cart failed');
      animateQuickAdd(submit);
      await refreshCart();
      showAddedToast(productForm.classList.contains('fur-card-quick-add') ? 'Product toegevoegd zonder je plek te verliezen.' : 'Product toegevoegd. Open je winkelwagen rechtsboven.');
      if (!productForm.classList.contains('fur-card-quick-add')) {
        productForm.classList.add('is-added-confirmed');
        window.setTimeout(() => productForm.classList.remove('is-added-confirmed'), 1400);
      }
    } catch (e) {
      // Blijf op de huidige pagina en open nooit automatisch /cart bij fouten/uitverkocht.
      if (e && e.message !== 'Variant sold out') console.warn('Add to cart blocked:', e);
    } finally {
      if (submit) {
        if (submit.classList.contains('fur-product-card__plus')) {
          submit.classList.remove('is-loading');
          submit.textContent = '+';
          submit.setAttribute('aria-label', 'Toevoegen aan winkelwagen');
        } else {
          submit.textContent = submit.dataset.originalText || original || 'Toevoegen aan winkelwagen';
        }
        // Product form button availability wordt daarna weer door updateVariant bepaald.
        if (!productForm.classList.contains('fur-product-form')) submit.disabled = false;
        if (productForm.classList.contains('fur-product-form')) {
          form?.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
  });


  document.addEventListener('click', async (event) => {
    const removeBtn = event.target.closest('[data-fur-remove-item]');
    if (!removeBtn) return;
    event.preventDefault();
    const key = removeBtn.getAttribute('data-fur-remove-item');
    const currentQty = Math.max(Number(removeBtn.getAttribute('data-fur-remove-qty') || 1), 1);
    const nextQty = Math.max(currentQty - 1, 0);
    const line = removeBtn.closest('.fur-cart-drawer__item');
    if (!key || removeBtn.disabled) return;
    removeBtn.disabled = true;
    line?.classList.add(nextQty === 0 ? 'is-removing' : 'is-decrementing');
    try {
      await new Promise((resolve) => setTimeout(resolve, 210));
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: nextQty })
      });
      await refreshCart();
    } catch (e) {
      line?.classList.remove('is-removing', 'is-decrementing');
      removeBtn.disabled = false;
    }
  });



  // PDP gallery slider
  const pdp = document.querySelector('[data-fur-pdp]');
  if (pdp) {
    const slides = Array.from(pdp.querySelectorAll('[data-fur-gallery-slide]'));
    const prev = pdp.querySelector('[data-fur-gallery-prev]');
    const next = pdp.querySelector('[data-fur-gallery-next]');
    const indexEl = pdp.querySelector('[data-fur-gallery-index]');
    let current = 0;
    const updateGallery = (idx) => {
      if (!slides.length) return;
      current = (idx + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      if (indexEl) indexEl.textContent = String(current + 1);
    };
    prev?.addEventListener('click', () => updateGallery(current - 1));
    next?.addEventListener('click', () => updateGallery(current + 1));
    updateGallery(0);
  }



  // Combined Listings/Grouptify: use one app mount only and hide helper once the app injects swatches.
  document.querySelectorAll('.fur-combined-listings').forEach((wrap) => {
    const colourBlock = wrap.closest('.fur-pdp-colour');
    const updateAppState = () => {
      const text = (wrap.textContent || '').trim();
      const appNodes = wrap.querySelectorAll('a, button, input, select, img, [role="button"], [class*="swatch"], [class*="variant"], [class*="grouptify"], [data-app-block]');
      const hasVisibleContent = Array.from(appNodes).some((node) => {
        const rect = node.getBoundingClientRect();
        return rect.width > 2 && rect.height > 2;
      });
      colourBlock?.classList.toggle('has-app-swatches', Boolean(text || hasVisibleContent));
    };
    updateAppState();
    new MutationObserver(updateAppState).observe(wrap, { childList: true, subtree: true, attributes: true, characterData: true });
    window.setTimeout(updateAppState, 600);
    window.setTimeout(updateAppState, 1800);
    window.setTimeout(updateAppState, 3500);
  });



  // Newsletter popup — shown once after a short delay, closes permanently per browser.
  const newsletterPopup = document.querySelector('[data-fur-newsletter-popup]');
  const newsletterKey = 'furNewsletterPopupClosed';
  const openNewsletterPopup = () => {
    if (!newsletterPopup || localStorage.getItem(newsletterKey) === '1') return;
    body.classList.add('fur-newsletter-popup-open');
    newsletterPopup.setAttribute('aria-hidden', 'false');
  };
  const closeNewsletterPopup = () => {
    body.classList.remove('fur-newsletter-popup-open');
    newsletterPopup?.setAttribute('aria-hidden', 'true');
    try { localStorage.setItem(newsletterKey, '1'); } catch(e) {}
  };
  if (newsletterPopup && localStorage.getItem(newsletterKey) !== '1') {
    window.setTimeout(openNewsletterPopup, 9000);
    document.addEventListener('mouseleave', (event) => {
      if (event.clientY <= 0 && window.innerWidth > 900) openNewsletterPopup();
    });
    document.querySelectorAll('[data-fur-newsletter-close]').forEach((el) => el.addEventListener('click', closeNewsletterPopup));
  }


  // v68 — subtle reveal micro-interactions without layout shift.
  const revealItems = document.querySelectorAll('.fur-product-card, .fur-pdp-stylewith, .fur-pdp-like, .fur-recently-viewed, .fur-footer__signup, .fur-cart-drawer__recommendations');
  if ('IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fur-in-view');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    revealItems.forEach((el) => {
      el.classList.add('fur-reveal');
      revealObserver.observe(el);
    });
  } else {
    revealItems.forEach((el) => el.classList.add('fur-in-view'));
  }

  // Premium cursor follower — direct, no lag.
  const cursor = document.querySelector('.fur-cursor');
  const cursorDot = document.querySelector('.fur-cursor-dot');
  if (cursor && window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
    const move = (event) => {
      body.classList.add('fur-cursor-ready');
      cursor.style.transform = `translate3d(${event.clientX}px, ${event.clientY}px, 0) translate(-50%, -50%)`;
      if (cursorDot) cursorDot.style.transform = `translate3d(${event.clientX}px, ${event.clientY}px, 0) translate(-50%, -50%)`;
    };
    document.documentElement.classList.add('fur-native-cursor-hidden');
    document.addEventListener('pointermove', move, { passive: true });
    document.addEventListener('mouseleave', () => body.classList.remove('fur-cursor-ready'));
    document.addEventListener('mouseenter', () => body.classList.add('fur-cursor-ready'));
    document.querySelectorAll('a, button, input, select, textarea, summary, .fur-product-card__media, .fur-mega-product').forEach((el) => {
      el.addEventListener('mouseenter', () => body.classList.add('fur-cursor-hover'));
      el.addEventListener('mouseleave', () => body.classList.remove('fur-cursor-hover'));
    });
  }



  // v54 — own restock backend submit
  document.querySelectorAll('[data-fur-restock-form]').forEach((restockForm) => {
    restockForm.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = restockForm.querySelector('[type="submit"]');
      const success = restockForm.querySelector('[data-fur-restock-success]');
      const error = restockForm.querySelector('[data-fur-restock-error]');
      success?.setAttribute('hidden', 'hidden');
      error?.setAttribute('hidden', 'hidden');
      const original = button?.textContent || 'Meld mij';
      if (button) { button.disabled = true; button.textContent = 'Bezig...'; }
      try {
        const formData = new FormData(restockForm);
        const response = await fetch(restockForm.action, {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok || data.ok === false) throw new Error(data.error || 'Restock signup failed');
        success?.removeAttribute('hidden');
        restockForm.classList.add('is-success');
      } catch (e) {
        error?.removeAttribute('hidden');
      } finally {
        if (button) { button.disabled = false; button.textContent = original; }
      }
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeSearch();
    closeCart();
    shopTrigger?.classList.remove('is-open');
  });


  // v42 — show native cursor inside Shopify cookie/privacy banner zones.
  const nativeCursorZoneSelectors = [
    '#shopify-pc__banner',
    '#shopify-pc__preferences',
    '[id^="shopify-pc__"]',
    '[class*="shopify-pc__"]'
  ].join(',');
  document.addEventListener('mouseover', (event) => {
    if (event.target.closest(nativeCursorZoneSelectors)) {
      body.classList.add('fur-native-cursor-zone-active');
    }
  });
  document.addEventListener('mouseout', (event) => {
    if (!event.relatedTarget || !event.relatedTarget.closest || !event.relatedTarget.closest(nativeCursorZoneSelectors)) {
      body.classList.remove('fur-native-cursor-zone-active');
    }
  });


  // v79 — swipeable auto-moving mobile rails for related product sections.
  const setupMobileRails = () => {
    if (!window.matchMedia('(max-width: 900px)').matches) return;
    document.querySelectorAll('.fur-pdp-stylewith__grid, .fur-pdp-like__grid, .fur-recently-viewed__grid').forEach((rail) => {
      if (rail.dataset.furMobileMarqueeReady === 'true') return;
      const cards = Array.from(rail.children).filter((el) => el.classList && el.classList.contains('fur-product-card'));
      if (cards.length < 2) return;
      cards.forEach((card) => rail.appendChild(card.cloneNode(true)));
      rail.classList.add('is-mobile-marquee');
      rail.dataset.furMobileMarqueeReady = 'true';
      let paused = false;
      let resumeTimer = null;
      const speed = 0.38;
      const pause = () => { window.clearTimeout(resumeTimer); paused = true; rail.classList.add('is-user-paused'); };
      const resume = () => { window.clearTimeout(resumeTimer); resumeTimer = window.setTimeout(() => { paused = false; rail.classList.remove('is-user-paused'); }, 1300); };
      ['touchstart','pointerdown','mouseenter','focusin'].forEach((evt) => rail.addEventListener(evt, pause, { passive: true }));
      ['touchmove','wheel'].forEach((evt) => rail.addEventListener(evt, pause, { passive: true }));
      ['touchend','pointerup','mouseleave','focusout'].forEach((evt) => rail.addEventListener(evt, resume, { passive: true }));
      const tick = () => {
        if (!paused && rail.scrollWidth > rail.clientWidth + 20) {
          rail.scrollLeft += speed;
          if (rail.scrollLeft >= (rail.scrollWidth / 2)) rail.scrollLeft = 0;
        }
        window.requestAnimationFrame(tick);
      };
      window.requestAnimationFrame(tick);
    });
  };
  setupMobileRails();
  window.setTimeout(setupMobileRails, 400);
  window.setTimeout(setupMobileRails, 1200);
  window.addEventListener('resize', setupMobileRails, { passive: true });

});
/* v78 — make dynamically inserted cart recommendation quick-add buttons animate cleanly */
document.addEventListener('click', function(event){
  const btn = event.target.closest('.fur-cart-rec-wrap .fur-product-card__plus');
  if (!btn) return;
  btn.classList.add('is-pulsing');
  window.setTimeout(() => btn.classList.remove('is-pulsing'), 700);
}, { passive: true });


/* v98 — Account drawer, wishlist, notifications and preferred profile data */
(function(){
  const API_BASE = 'https://minetale.nl/faireunreve/account/api';
  const tokenKeys = ['fur_club_session_v3','fur_club_session_v2','fur_club_session'];
  const state = window.FURClubState = window.FURClubState || { member:null, wishlistIds:new Set() };
  const getToken = () => { for (const key of tokenKeys){ try{ const t=localStorage.getItem(key) || sessionStorage.getItem(key); if(t) return t; }catch(e){} } return ''; };
  const setToken = (token) => { if(!token) return; tokenKeys.forEach(k=>{ try{ localStorage.setItem(k,token); sessionStorage.setItem(k,token); }catch(e){} }); };
  const clearToken = () => tokenKeys.forEach(k=>{ try{ localStorage.removeItem(k); sessionStorage.removeItem(k); }catch(e){} });
  const api = async (path, options={}) => {
    const token=getToken(); const glue=path.includes('?')?'&':'?'; const url=API_BASE+path+(token?glue+'token='+encodeURIComponent(token):'');
    const headers=Object.assign({}, options.headers||{}, token?{'Authorization':'Bearer '+token,'X-FUR-Club-Token':token}:{});
    const res=await fetch(url, Object.assign({cache:'no-store'}, options, {headers}));
    const data=await res.json().catch(()=>({}));
    if(!res.ok || !data.ok) throw new Error(data.error || 'Er ging iets mis.');
    return data;
  };
  const body=document.body, drawer=document.querySelector('[data-fur-account-drawer]'), form=document.querySelector('[data-fur-account-login-form]'), msg=document.querySelector('[data-fur-account-message]');
  const openers=document.querySelectorAll('[data-fur-account-open]');
  const setMessage=(text,type='info')=>{ if(!msg) return; msg.hidden=false; msg.textContent=text; msg.dataset.type=type; };
  const resetMessage=()=>{ if(!msg) return; msg.hidden=true; msg.textContent=''; delete msg.dataset.type; };
  const open=()=>{ body.classList.add('fur-account-open'); drawer?.setAttribute('aria-hidden','false'); loadMini(true); setTimeout(()=>{ if(!getToken()) drawer?.querySelector('input[type="email"]')?.focus(); },220); };
  const close=()=>{ body.classList.remove('fur-account-open'); drawer?.setAttribute('aria-hidden','true'); };
  function escapeHtml(v=''){ return String(v).replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m])); }

  function persistPreferences(member){
    try{
      if(member?.preferences?.preferred_shirt_size) localStorage.setItem('fur_preferred_shirt_size', member.preferences.preferred_shirt_size);
      if(member?.preferences?.preferred_pants_size) localStorage.setItem('fur_preferred_pants_size', member.preferences.preferred_pants_size);
      if(member?.preferences?.display_name) localStorage.setItem('fur_display_name', member.preferences.display_name);
    }catch(e){}
  }
  function renderNotifications(member){
    const list=document.querySelector('[data-fur-notification-list]');
    const badge=document.querySelector('[data-fur-notification-count]');
    const notifications=Array.isArray(member?.notifications)?member.notifications:[];
    if(badge){ badge.hidden = notifications.length === 0; badge.textContent = notifications.length > 9 ? '9+' : String(notifications.length || ''); }
    if(list){ list.innerHTML = notifications.length ? notifications.slice(0,3).map(item=>`<a class="fur-mini-item" href="${escapeHtml(item.href||'/pages/club')}"><strong>${escapeHtml(item.title||'Update')}</strong><span>${escapeHtml(item.text||'')}</span></a>`).join('') : '<span>Er staan nog geen meldingen klaar.</span>'; }
  }
  function renderWishlistPreview(member){
    const list=document.querySelector('[data-fur-wishlist-list]');
    const badge=document.querySelector('[data-fur-wishlist-count]');
    const wishlist=Array.isArray(member?.wishlist)?member.wishlist:[];
    state.wishlistIds = new Set(wishlist.map(item => String(item.product_id)));
    if(badge){ badge.hidden = wishlist.length === 0; badge.textContent = wishlist.length > 9 ? '9+' : String(wishlist.length || ''); }
    if(list){ list.innerHTML = wishlist.length ? wishlist.slice(0,3).map(item=>`<a class="fur-mini-item fur-mini-item--wish" href="${escapeHtml(item.product_url||'/pages/club?view=wishlist')}">${item.image_url?`<img src="${escapeHtml(item.image_url)}" alt="">`:''}<div><strong>${escapeHtml(item.product_title||'Product')}</strong><span>${escapeHtml(item.price||'')}</span></div></a>`).join('') : '<span>Je wishlist is nog leeg.</span>'; }
    syncWishlistButtons();
  }
  function renderMini(member){
    state.member = member || null;
    const email=member?.email||'Club member', name=member?.name || member?.preferences?.display_name || email, points=Number(member?.spendable_points ?? member?.points ?? 0), tier=member?.tier || 'Dreamer';
    document.querySelectorAll('[data-fur-account-logged-out]').forEach(el=>el.hidden=true);
    document.querySelectorAll('[data-fur-account-logged-in]').forEach(el=>el.hidden=false);
    document.querySelectorAll('[data-fur-account-email],[data-fur-account-popover-email]').forEach(el=>el.textContent=name);
    document.querySelectorAll('[data-fur-account-avatar]').forEach(el=>el.textContent=name.slice(0,2).toUpperCase());
    document.querySelectorAll('[data-fur-account-tier]').forEach(el=>el.textContent=tier); document.querySelectorAll('[data-fur-account-popover-card-tier]').forEach(el=>el.textContent=tier);
    document.querySelectorAll('[data-fur-account-points]').forEach(el=>el.textContent=points);
    document.querySelectorAll('[data-fur-account-popover-meta]').forEach(el=>el.textContent=`${points} punten`); document.querySelectorAll('[data-fur-account-popover-primary]').forEach(el=>{ el.textContent='Dashboard'; el.href='/pages/club'; });
    document.querySelectorAll('[data-fur-account-popover-points]').forEach(el=>el.textContent=points);
    document.querySelectorAll('[data-fur-account-popover-stats]').forEach(el=>el.hidden=false);document.querySelectorAll('[data-fur-account-popover-bar]').forEach(el=>el.hidden=false);const life=Number(member?.lifetime_points??points), next=Number(member?.next_tier_points||500), pct=next>life?Math.max(5,Math.min(100,Math.round((life/next)*100))):100;document.querySelectorAll('[data-fur-account-popover-bar-fill]').forEach(el=>el.style.width=pct+'%');
    persistPreferences(member); renderNotifications(member); renderWishlistPreview(member); document.querySelectorAll('[data-fur-admin-link]').forEach(el=>{ el.hidden = !member?.is_admin; }); window.FURClubLatestMember = member; body.classList.add('fur-club-session-active'); resetMessage();
  }
  function renderLoggedOut(){
    state.member=null; state.wishlistIds = new Set();
    document.querySelectorAll('[data-fur-account-logged-out]').forEach(el=>el.hidden=false);
    document.querySelectorAll('[data-fur-account-logged-in]').forEach(el=>el.hidden=true);
    document.querySelectorAll('[data-fur-account-popover-email]').forEach(el=>el.textContent='Niet ingelogd');
    document.querySelectorAll('[data-fur-account-popover-meta]').forEach(el=>el.textContent='Inloggen'); document.querySelectorAll('[data-fur-account-popover-primary]').forEach(el=>{ el.textContent='Inloggen'; el.href='/pages/club'; });
    document.querySelectorAll('[data-fur-account-avatar]').forEach(el=>el.textContent='--');
    document.querySelectorAll('[data-fur-account-popover-stats]').forEach(el=>el.hidden=true);document.querySelectorAll('[data-fur-account-popover-bar]').forEach(el=>el.hidden=true);document.querySelectorAll('[data-fur-account-popover-logged-in]').forEach(el=>el.hidden=true);
    const badgeN=document.querySelector('[data-fur-notification-count]'); if(badgeN) badgeN.hidden=true; document.querySelectorAll('[data-fur-admin-link]').forEach(el=>el.hidden=true);
    const badgeW=document.querySelector('[data-fur-wishlist-count]'); if(badgeW) badgeW.hidden=true;
    const notif=document.querySelector('[data-fur-notification-list]'); if(notif) notif.innerHTML='<span>Log in voor meldingen over drops en punten.</span>';
    const wish=document.querySelector('[data-fur-wishlist-list]'); if(wish) wish.innerHTML='<span>Log in om je wishlist op te bouwen.</span>';
    syncWishlistButtons(); body.classList.remove('fur-club-session-active');
  }
  async function loadMini(force=false){
    if(!force && window.FURClubLatestMember){ renderMini(window.FURClubLatestMember); return; }
    if(!getToken()) return renderLoggedOut();
    try{ const data=await api('/dashboard.php'); if(data.member) renderMini(data.member); else renderLoggedOut(); }catch(e){ renderLoggedOut(); }
  }
  function goToSettings(e){
    e.preventDefault(); close();
    const onClub = /\/pages\/club\/?$/.test(window.location.pathname) || /\/club\/?$/.test(window.location.pathname);
    if(!onClub){ window.location.href='/pages/club?view=settings'; return; }
    const url=new URL(window.location.href); url.hash=''; url.searchParams.set('view','settings'); window.history.replaceState({},'',url.toString()); window.dispatchEvent(new CustomEvent('fur:club:settings-requested'));
  }
  openers.forEach(a=>a.addEventListener('click', (e)=>{ e.preventDefault(); open(); }));
  document.querySelectorAll('[data-fur-account-close]').forEach(el=>el.addEventListener('click', close));
  document.querySelectorAll('[data-fur-account-settings-link]').forEach(el=>el.addEventListener('click', goToSettings));
  form?.addEventListener('submit', async (e)=>{ e.preventDefault(); const btn=form.querySelector('button'); const email=new FormData(form).get('email'); btn.disabled=true; btn.textContent='Bezig...'; try{ const res=await fetch(API_BASE+'/request-login.php',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({email})}); const data=await res.json().catch(()=>({})); if(!res.ok || data.ok===false) throw new Error(data.error || 'Versturen mislukt.'); setMessage('Check je inbox. We hebben je login link verstuurd.', 'success'); } catch(err){ setMessage(err.message || 'Versturen mislukt. Probeer opnieuw.', 'error'); } finally{ btn.disabled=false; btn.textContent='Stuur login link'; } });
  document.querySelectorAll('[data-fur-account-logout]').forEach(btn=>btn.addEventListener('click',()=>{ clearToken(); window.FURClubLatestMember=null; renderLoggedOut(); setMessage('Je bent uitgelogd.','info'); window.dispatchEvent(new CustomEvent('fur:club:logout')); }));
  window.addEventListener('fur:club:member', (event)=>{ if(event.detail?.member) renderMini(event.detail.member); });
  window.addEventListener('fur:club:logout', renderLoggedOut);
  function getWishlistPayload(btn){ return { product_id:Number(btn.dataset.productId||0), variant_id:btn.dataset.variantId || '', product_title:btn.dataset.productTitle || '', product_url:btn.dataset.productUrl || window.location.pathname, image_url:btn.dataset.imageUrl || '', price:btn.dataset.price || '' }; }
  function syncWishlistButtons(){ document.querySelectorAll('[data-fur-wishlist-toggle]').forEach(btn=>{ const active=state.wishlistIds.has(String(btn.dataset.productId||'')); btn.classList.toggle('is-active', active); btn.setAttribute('aria-pressed', active ? 'true' : 'false'); }); }
  document.addEventListener('click', async (event)=>{
    const btn = event.target.closest('[data-fur-wishlist-toggle]'); if(!btn) return; event.preventDefault();
    const token=getToken(); if(!token){ open(); setMessage('Log in om items op te slaan in je wishlist.', 'info'); return; }
    btn.disabled=true; btn.classList.add('is-saving'); setTimeout(()=>btn.classList.remove('is-saving'),700); const active=state.wishlistIds.has(String(btn.dataset.productId||''));
    try{ const endpoint = active ? '/wishlist-remove.php' : '/wishlist-add.php'; await api(endpoint, {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(getWishlistPayload(btn))}); await loadMini(true); }catch(err){ console.error(err); } finally{ btn.disabled=false; }
  });
  function applyPreferredSize(){
    let prefShirt='', prefPants='';
    try{ prefShirt=localStorage.getItem('fur_preferred_shirt_size')||''; prefPants=localStorage.getItem('fur_preferred_pants_size')||''; }catch(e){}
    const sizeInputs=Array.from(document.querySelectorAll('.fur-pdp-option--sizes input[type="radio"]'));
    if(!sizeInputs.length) return;
    const pdp=document.querySelector('[data-fur-pdp]');
    const productText=[
      pdp?.dataset?.productTitle || '',
      pdp?.dataset?.productType || '',
      pdp?.dataset?.productTags || '',
      document.querySelector('h1')?.textContent || '',
      Array.from(document.querySelectorAll('.fur-pdp-option--sizes legend')).map(el=>el.textContent||'').join(' ')
    ].join(' ').toLowerCase();
    const pantsKeywords=/(broek|broeken|pant|pants|jeans|denim|cargo|shorts|short|jogger|jogging|trouser|trousers|bottom|bottoms)/;
    const topKeywords=/(shirt|t-shirt|tee|hoodie|sweater|crewneck|vest|jacket|jas|top|tops)/;
    const looksLikePants=pantsKeywords.test(productText) && !topKeywords.test(productText.replace(/pantsuit/g,''));
    const values=new Set(sizeInputs.map(input=>String(input.value||'')));
    const preferred=[];
    if(looksLikePants){ preferred.push(prefPants, prefShirt); } else { preferred.push(prefShirt, prefPants); }
    const pref=preferred.find(v=>v && values.has(String(v)));
    if(!pref) return;
    const escaped=(window.CSS&&CSS.escape)?CSS.escape(pref):String(pref).replace(/"/g,'\\"');
    const input=document.querySelector(`.fur-pdp-option--sizes input[value="${escaped}"]`);
    if(input && !input.disabled && !input.checked){ input.click(); }
  }
  window.FURAccountDrawer = { load: loadMini, renderMini, renderLoggedOut, setToken, clearToken };
  document.addEventListener('DOMContentLoaded', ()=>loadMini(false)); loadMini(false); setTimeout(applyPreferredSize, 650);
})();


/* v105 — one stable header dropdown system */
(function(){
  const wraps=[...document.querySelectorAll('[data-fur-menu-wrap]')];
  if(!wraps.length) return;
  let active=null, timer=null;
  const closeAll=(delay=160)=>{ clearTimeout(timer); timer=setTimeout(()=>{ wraps.forEach(w=>w.classList.remove('is-menu-open')); active=null; },delay); };
  const open=(wrap)=>{ clearTimeout(timer); wraps.forEach(w=>{ if(w!==wrap) w.classList.remove('is-menu-open'); }); wrap.classList.add('is-menu-open'); active=wrap; };
  wraps.forEach(wrap=>{
    const trigger=wrap.querySelector('[data-fur-menu-trigger]');
    const panel=wrap.querySelector('[data-fur-menu-panel]');
    wrap.addEventListener('mouseenter',()=>open(wrap));
    wrap.addEventListener('mouseleave',()=>closeAll(260));
    panel?.addEventListener('mouseenter',()=>open(wrap));
    panel?.addEventListener('mouseleave',()=>closeAll(260));
    trigger?.addEventListener('focus',()=>open(wrap));
    trigger?.addEventListener('click',(e)=>{
      if(wrap.dataset.furMenuWrap==='account'){ e.preventDefault(); open(wrap); return; }
      if(window.matchMedia('(hover: none)').matches && !wrap.classList.contains('is-menu-open')){ e.preventDefault(); open(wrap); }
    });
  });
  document.addEventListener('click',(e)=>{ if(active && !active.contains(e.target)) closeAll(0); });
  document.addEventListener('keydown',(e)=>{ if(e.key==='Escape') closeAll(0); });
})();

/* v107 wishlist save animation */
document.addEventListener('click', function(event){
  const btn = event.target.closest('[data-fur-wishlist-toggle]');
  if (!btn) return;
  btn.classList.remove('fur-wishlist-pulse');
  void btn.offsetWidth;
  btn.classList.add('fur-wishlist-pulse');
  setTimeout(()=>btn.classList.remove('fur-wishlist-pulse'), 900);
}, {capture:true});
window.addEventListener('fur:wishlist:pulse-v107', function(){});


/* v108 — same-device login, admin visibility, compact hover stability, mail code formatting */
(function(){
  const API_BASE = 'https://minetale.nl/faireunreve/account/api';
  const tokenKeys = ['fur_club_session_v3','fur_club_session_v2','fur_club_session'];
  const deviceKey = 'fur_club_device_id_v1';
  const pendingKey = 'fur_club_pending_login_v1';
  const getDeviceId = () => {
    try{
      let id = localStorage.getItem(deviceKey);
      if(!id){
        id = (crypto && crypto.randomUUID) ? crypto.randomUUID() : ('dev_'+Date.now()+'_'+Math.random().toString(16).slice(2));
        localStorage.setItem(deviceKey,id);
      }
      return id;
    }catch(e){ return 'dev_'+Date.now(); }
  };
  const getToken = () => { for (const k of tokenKeys){ try{ const t=localStorage.getItem(k)||sessionStorage.getItem(k); if(t) return t; }catch(e){} } return ''; };
  const setToken = (token) => { if(!token) return; tokenKeys.forEach(k=>{ try{ localStorage.setItem(k,token); sessionStorage.setItem(k,token); }catch(e){} }); };
  const requestHeaders = (extra={}) => Object.assign({'Content-Type':'application/json'}, extra);
  const postJson = async (url, body) => {
    const res = await fetch(url,{method:'POST',headers:requestHeaders(),body:JSON.stringify(body),cache:'no-store'});
    const data = await res.json().catch(()=>({}));
    if(!res.ok || data.ok===false) throw new Error(data.error || data.debug || 'Er ging iets mis.');
    return data;
  };
  async function pollPendingLogin(messageEl){
    let pending=null;
    try{ pending=JSON.parse(localStorage.getItem(pendingKey)||'null'); }catch(e){}
    if(!pending || !pending.request_id || !pending.device_id || pending.done) return;
    const started = Date.now();
    const timer = setInterval(async()=>{
      if(Date.now()-started > 1000*60*25){ clearInterval(timer); return; }
      try{
        const d = await postJson(API_BASE+'/login-status.php',{request_id:pending.request_id,device_id:pending.device_id});
        if(d.session_token){ setToken(d.session_token); pending.done=true; localStorage.setItem(pendingKey,JSON.stringify(pending)); clearInterval(timer); if(messageEl){messageEl.hidden=false;messageEl.dataset.type='success';messageEl.textContent='Je bent ingelogd op dit apparaat.';} location.href='/pages/club'; }
        else if(d.pending && messageEl){ messageEl.hidden=false; messageEl.dataset.type='info'; messageEl.textContent='Open de link in je mail. Je wordt automatisch op dit apparaat ingelogd.'; }
      }catch(e){}
    }, 2500);
  }
  async function interceptLoginForm(form){
    const btn=form.querySelector('button[type="submit"],button');
    const msg=form.closest('section,div,aside')?.querySelector('[data-fur-account-message],[data-club-message]') || document.querySelector('[data-fur-account-message],[data-club-message]');
    form.addEventListener('submit', async (e)=>{
      e.preventDefault(); e.stopImmediatePropagation();
      const email=new FormData(form).get('email');
      const device_id=getDeviceId();
      const request_id=(crypto && crypto.randomUUID) ? crypto.randomUUID() : ('req_'+Date.now()+'_'+Math.random().toString(16).slice(2));
      if(btn){ btn.disabled=true; btn.textContent='Bezig...'; }
      try{
        const d=await postJson(API_BASE+'/request-login.php',{email,device_id,request_id});
        localStorage.setItem(pendingKey,JSON.stringify({request_id:d.request_id||request_id,device_id,created_at:Date.now()}));
        if(msg){ msg.hidden=false; msg.dataset.type='success'; msg.textContent='Check je inbox. Open de link, dan loggen we dit apparaat automatisch in.'; }
        pollPendingLogin(msg);
      }catch(err){ if(msg){ msg.hidden=false; msg.dataset.type='error'; msg.textContent=err.message||'Versturen mislukt.'; } }
      finally{ if(btn){ btn.disabled=false; btn.textContent='Stuur login link'; } }
    }, true);
  }
  document.querySelectorAll('[data-fur-account-login-form],[data-club-login-form]').forEach(interceptLoginForm);
  document.addEventListener('DOMContentLoaded',()=>pollPendingLogin(document.querySelector('[data-fur-account-message],[data-club-message]')));

  const params = new URL(location.href).searchParams;
  const magicToken = params.get('token');
  if(magicToken){
    const device_id=getDeviceId();
    postJson(API_BASE+'/verify-login.php',{token:magicToken,device_id}).then(d=>{
      if(d.session_token){ setToken(d.session_token); }
      const u=new URL(location.href); u.searchParams.delete('token'); history.replaceState({},'',u.toString());
      if(d.session_token) location.href='/pages/club';
      else document.body.classList.add('fur-login-approved-other-device');
    }).catch(()=>{});
  }

  function syncAdminVisibility(member){
    const isAdmin = !!(member && (member.is_admin || member.admin_role || (member.admin_permissions && Object.keys(member.admin_permissions).length)));
    document.querySelectorAll('[data-fur-admin-link],[data-club-admin-link],[data-fur-admin-only]').forEach(el=>{
      el.hidden = !isAdmin; el.setAttribute('aria-hidden', isAdmin ? 'false':'true');
    });
  }
  window.addEventListener('fur:club:member', e=>syncAdminVisibility(e.detail && e.detail.member));
  window.addEventListener('fur:club:logout', ()=>syncAdminVisibility(null));
  syncAdminVisibility(window.FURClubLatestMember || null);

  function formatCodeBlocks(container=document){
    container.querySelectorAll('.fur-mail-body').forEach(box=>{
      const txt=box.textContent||'';
      if((txt.match(/[{};]/g)||[]).length>8 && !box.querySelector('pre')){
        box.innerHTML='<pre class="fur-mail-codeblock"></pre>';
        box.querySelector('pre').textContent=txt;
      }
    });
  }
  const obs=new MutationObserver(()=>formatCodeBlocks());
  obs.observe(document.body,{childList:true,subtree:true});
  formatCodeBlocks();

  // Keep account popover compact + stable; notification/wishlist keep their own dropdowns.
  document.querySelectorAll('[data-fur-menu-wrap]').forEach(wrap=>{
    let timer;
    const open=()=>{clearTimeout(timer);document.querySelectorAll('[data-fur-menu-wrap]').forEach(x=>{if(x!==wrap)x.classList.remove('is-menu-open')});wrap.classList.add('is-menu-open')};
    const close=()=>{clearTimeout(timer);timer=setTimeout(()=>wrap.classList.remove('is-menu-open'),260)};
    wrap.addEventListener('mouseenter',open); wrap.addEventListener('mouseleave',close);
    wrap.querySelector('[data-fur-menu-trigger]')?.addEventListener('focus',open);
    wrap.querySelector('[data-fur-menu-trigger]')?.addEventListener('click',e=>{ if(wrap.dataset.furMenuWrap==='account'){ e.preventDefault(); open(); }});
  });
})();


/* v116 — dashboard/admin light-mode toggle */
(function(){
  function apply(){
    const mode=localStorage.getItem('fur_ui_mode')||'dark';
    document.documentElement.classList.toggle('fur-ui-light', mode==='light');
    const btn=document.querySelector('[data-fur-ui-mode-toggle]'); if(btn) btn.querySelector('span').textContent=mode==='light'?'Dark mode':'Light mode';
  }
  function ensure(){
    if(!document.querySelector('.fur-club-neo') && !document.querySelector('.fur-admin-panel')) return;
    if(document.querySelector('[data-fur-ui-mode-toggle]')) return apply();
    const btn=document.createElement('button'); btn.type='button'; btn.className='fur-ui-mode-toggle'; btn.dataset.furUiModeToggle=''; btn.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="4"></circle><path d="M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M19.1 4.9l-1.4 1.4M6.3 17.7l-1.4 1.4"></path></svg><span>Light mode</span>';
    btn.addEventListener('click',()=>{const next=(localStorage.getItem('fur_ui_mode')||'dark')==='light'?'dark':'light';localStorage.setItem('fur_ui_mode',next);apply();});
    document.body.appendChild(btn); apply();
  }
  document.addEventListener('DOMContentLoaded',ensure); ensure();
})();
